import  { useState, useEffect } from 'react';
import { FirestoreService } from '../services/firestoreService';
import { HashedDataService } from '../services/hashedDataService/hashedDataService';
import { DataGrid } from '@material-ui/data-grid';
import ArticleManager from '../forms/articleManager/articleManager';

function Admin() {
  const projectCollection = '/project_enquiry'; //collection name
  const hashedUserCollection = '/hashedData'; //collection name
  const firestoreService = new FirestoreService(projectCollection); // nosql database service
  //const hashedDataService = new HashedDataService(hashedUserCollection); // nosql database service
  /*********************** Hooks varaiables start here*************************/
  const [projectEnquiryDocs, setProjectEnquiryDocs] = useState([]) // hooks for project Enquiry form submitted data
  //const [hashedUser, setHashedUser] = useState('') // hooks for project Enquiry form submitted data
  /************************ Hooks varaiables end here**************************/

  /******************Hooks functions start here********************************/
  const cookieUserInfo = document.cookie.split('; ').find(row => row.startsWith('user=')).split('=')[1];
  const hashedCode = '36efcdce703a719c8f7847c3b739015851a73b3b339f5fd68e707e439dd784f7';
  const fetchProjectEnquiryDocs = async ()=> {
  const data = await firestoreService.getData();
   setProjectEnquiryDocs([...data])
 }

 useEffect(() => {
   fetchProjectEnquiryDocs();
 }, [])
/*
//getter for hashed user
 const getHashedUser = async ()=> {
 const data = await hashedDataService.getHashedUserData();
  setHashedUser(data)
}

useEffect(() => {
  getHashedUser();
}, [])
*/
/******************Hooks functions ends here********************************/
if(cookieUserInfo.toString()==hashedCode){
   return (
    <div className="Admin">
    <ArticleManager />
    {
     projectEnquiryDocs && projectEnquiryDocs.map(doc=>{
        return(
          <div className="projectEnquiryDocs-container">
              <p>Name : {doc.name}</p>
              <p>Email : {doc.email}</p>
              <p>Phone : {doc.phone}</p>
              <p>Data : {doc.dataset}</p>
              <p>ML : {doc.ml}</p>
              <p>SDN : {doc.sdn}</p>
              <p>ICN : {doc.icn}</p>
              <p>Other : {doc.country_code}</p>
              <p>Other : {new Date(doc.date_time.seconds.toString()*1000).toString()}</p>
              <p>______________________________________________</p>
          </div>
          )
        })
      }
    </div>
);
}
else{
  return (
   <div>
   Login properly
   </div>
 );
}
}


export default Admin;
